import IconArrow from '@/assets/icons/order/mobile-version/icon-arrow-left.svg'
import IconCall from '@/assets/icons/order/mobile-version/icon-call.svg'
import { Link } from '@/i18n/navigation'
import { Button } from 'rsuite'
import styles from './mobile.module.scss'

const MobileHeader = ({ onClick }: any) => {
  return (
    <div className={styles.headerMobile}>
      <Button type="button" onClick={onClick} className={styles.btn}>
        <IconArrow />
      </Button>
      <div className={styles.text}>Оформление</div>
      <Link href="tel:+998712003100" className={styles.btn}>
        <IconCall />
      </Link>
    </div>
  )
}

export default MobileHeader
